import { Button, Form, Input, message } from 'antd';
import { FormComponentProps, FormItemProps } from 'antd/lib/form';
import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import 'src/assets/less/login.less';
import VerificationCodeButton from 'src/components/common/VerificationCodeButton';
import TencentCaptchaButton from 'src/components/common/TencentCaptchaButton';
import HeaderLogin from 'src/components/layouts/HeaderLogin';
import { IResetPassword, ResetByMobile, ResetByEmail } from 'src/entity/LoginParam';
import { RouterConfig } from 'src/routers/urlConfig';
import I18N from 'src/services/I18NService';
import LoginService from 'src/services/LoginService';
import { UtilRegExp } from 'src/utils/regExp';

interface IResetFormProps extends FormComponentProps, IResetPassword, RouteComponentProps {
  isDomestic: boolean;
}

class ResetForm extends React.Component<IResetFormProps> {
  constructor(props: IResetFormProps) {
    super(props);
  }

  canSubmit = true;

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        if (!this.canSubmit) {
          return;
        }
        try {
          if (this.props.isDomestic) {
            if (!UtilRegExp.isPhone(values.phone)) {
              message.error(I18N.get('err_mobile'));
              return;
            }
            const data: IResetPassword = {
              username: values.username,
              code: values.verifyCode,
              mobile: values.phone,
              password: values.password,
            };
            this.canSubmit = true;
            const resetRes = await LoginService.resetPassword(data, ResetByMobile);
            if (!!resetRes) {
              this.props.history.push(RouterConfig.Urls.login);
            }
            this.canSubmit = true;
          } else {
            if (!UtilRegExp.isEmail(values.email)) {
              message.error(I18N.get('err_email'));
              return;
            }
            const data: IResetPassword = {
              username: values.username,
              code: values.verifyCode,
              email: values.email,
              password: values.password,
            };
            this.canSubmit = true;
            const resetRes = await LoginService.resetPassword(data, ResetByEmail);
            if (!!resetRes) {
              this.props.history.push(RouterConfig.Urls.login);
            }
            this.canSubmit = true;
          }
        } catch (error) {
          this.canSubmit = false;
          if (!!error.response) {
            message.error(JSON.stringify(error.response.data));
          } else {
            message.error(I18N.get('err_submit_failure'));
          }
        }
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout: FormItemProps = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    };

    return (
      <div className="login-box">
        <HeaderLogin />
        <div className="login">
          <div className="reset-form-box">
            <div className="reset-logo">
              <div className="login-name">{I18N.get('login_reset_pwd')}</div>
            </div>
            <Form onSubmit={this.handleSubmit} className="reset-form">
              <Form.Item label={I18N.get('login_userName')} {...formItemLayout}>
                {getFieldDecorator(`username`, {
                  rules: [{ required: true, message: `${I18N.get('common_input')}${I18N.get('login_userName')}` }],
                })(<Input placeholder={I18N.get('login_userName')} />)}
              </Form.Item>
              {this.props.isDomestic && (
                <Form.Item label={I18N.get('common_mobile')} {...formItemLayout}>
                  {getFieldDecorator(`phone`, {
                    rules: [{ required: true, message: `${I18N.get('common_input')}${I18N.get('common_mobile')}` }],
                  })(<Input type="Number" maxLength={11} minLength={11} placeholder={I18N.get('common_mobile')} />)}
                </Form.Item>
              )}
              {this.props.isDomestic && (
                <Form.Item label={I18N.get('login_verify_code')} {...formItemLayout}>
                  {getFieldDecorator(`verifyCode`, {
                    rules: [{ required: true, message: `${I18N.get('common_input')}${I18N.get('login_verify_code')}` }],
                  })(
                    <Input
                      placeholder={I18N.get('login_verify_code')}
                      suffix={<TencentCaptchaButton isDomestic={true} phoneOrEmail={this.props.form.getFieldValue(`phone`)} />}
                    />
                  )}
                </Form.Item>
              )}
              {!this.props.isDomestic && (
                <Form.Item label="Email" {...formItemLayout}>
                  {getFieldDecorator(`email`, {
                    rules: [{ required: true, message: `${I18N.get('common_input')} email` }],
                  })(<Input type="email" placeholder="email" />)}
                </Form.Item>
              )}
              {!this.props.isDomestic && (
                <Form.Item label={I18N.get('login_verify_code')} {...formItemLayout}>
                  {getFieldDecorator(`verifyCode`, {
                    rules: [{ required: true, message: `${I18N.get('common_input')}${I18N.get('login_verify_code')}` }],
                  })(
                    <Input
                      placeholder={I18N.get('login_verify_code')}
                      suffix={<VerificationCodeButton isDomestic={false} phoneOrEmail={this.props.form.getFieldValue(`email`)} />}
                    />
                  )}
                </Form.Item>
              )}
              <Form.Item label={I18N.get('login_new_pwd')} {...formItemLayout}>
                {getFieldDecorator(`password`, {
                  rules: [{ required: true, message: `${I18N.get('common_input')}${I18N.get('login_new_pwd')}` }],
                })(<Input type="password" placeholder={I18N.get('login_pwd_require')} />)}
              </Form.Item>
              <Form.Item wrapperCol={{ span: 18, offset: 6 }} style={{ marginBottom: 0 }}>
                <Button type="primary" htmlType="submit" className="login-form-button">
                  {I18N.get('login_reset_pwd')}
                </Button>
                <p style={{ justifyContent: 'space-between' }}>
                  <Link to="/auth/login" className="login-form-forgot">
                    {I18N.get('common_or')} {I18N.get('login_to_login')}
                  </Link>
                </p>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

const ResetPage = Form.create<IResetFormProps>()(ResetForm);
export default ResetPage;



// WEBPACK FOOTER //
// ./src/components/views/Login/ResetPage.tsx